(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-backup-20260612"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (
        this.querySelector('details-modal details[open]') ||
        (this.predictiveSearch && this.predictiveSearch.isOpen)
      ) {
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zico-release-launch"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    }

    function getReleaseScope(root) {
      var mount = root.querySelector('[data-zico-release-launch-mount]');
      if (mount) return mount;

      return document.querySelector('[data-zico-release-mounted-for="' + root.id + '"]');
    }

    function updateLaunch(root) {
      var scope = getReleaseScope(root);
      if (!scope) return;

      var releaseAt = Date.parse(root.dataset.releaseAt || '');
      if (Number.isNaN(releaseAt)) return;

      var status = scope.querySelector('[data-zico-release-status]');
      var days = scope.querySelector('[data-zico-release-days]');
      var hours = scope.querySelector('[data-zico-release-hours]');
      var minutes = scope.querySelector('[data-zico-release-minutes]');
      var seconds = scope.querySelector('[data-zico-release-seconds]');
      var notify = scope.querySelector('[data-zico-release-notify]');
      var difference = releaseAt - Date.now();
      var isLive = difference <= 0;
      var totalSeconds = Math.floor(Math.max(0, difference) / 1000);
      var remainingDays = Math.floor(totalSeconds / 86400);
      var remainingHours = Math.floor((totalSeconds % 86400) / 3600);
      var remainingMinutes = Math.floor((totalSeconds % 3600) / 60);
      var remainingSeconds = totalSeconds % 60;

      if (days) days.textContent = pad(remainingDays);
      if (hours) hours.textContent = pad(remainingHours);
      if (minutes) minutes.textContent = pad(remainingMinutes);
      if (seconds) seconds.textContent = pad(remainingSeconds);

      if (isLive) {
        if (root.dataset.releaseState !== 'live') {
          root.dataset.releaseState = 'live';

          if (root.classList.contains('zico-release-launch--home')) {
            root.remove();
          } else {
            window.setTimeout(function () {
              window.location.reload();
            }, 250);
          }
        }
        return;
      } else {
        root.dataset.releaseState = 'upcoming';
        if (notify) notify.hidden = false;
      }
    }

    function mountProductPanel(root) {
      if (!root.classList.contains('zico-release-launch--product')) return;

      var mount = root.querySelector('[data-zico-release-launch-mount]');
      var main = document.querySelector('product-info[id^="MainProduct-"]');
      var info = main && main.querySelector('.product__info-container');
      var title = info && info.querySelector('.product__title');
      var variantPicker = info && info.querySelector('variant-selects');
      var mountTarget = variantPicker || title;

      if (!mount || !info || !mountTarget || mount.dataset.zicoReleaseMounted === 'true') return;

      var existing = info.querySelector('[data-zico-release-mounted-for="' + root.id + '"]');
      if (existing && existing !== mount) existing.remove();

      mountTarget.insertAdjacentElement('afterend', mount);
      mount.dataset.zicoReleaseMounted = 'true';
      mount.dataset.zicoReleaseMountedFor = root.id;
    }

    function boot(root) {
      if (!root || root.dataset.zicoReleaseReady === 'true') return;

      root.dataset.zicoReleaseReady = 'true';
      mountProductPanel(root);
      updateLaunch(root);
      if (!root.isConnected || root.dataset.releaseState === 'live') return;
      root.zicoReleaseTimer = window.setInterval(function () {
        if (!root.isConnected) {
          window.clearInterval(root.zicoReleaseTimer);
          return;
        }
        updateLaunch(root);
      }, 1000);
    }

    function bootAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-zico-release-launch]');
      roots.forEach(boot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        bootAll(document);
      }, { once: true });
    } else {
      bootAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      bootAll(event.target || document);
    });

    document.addEventListener('zico:product-colour-selected', function (event) {
      var html = event.detail && event.detail.html;
      if (!html || typeof html.querySelector !== 'function') return;
      var selector = '.zico-release-launch--product[data-zico-release-launch]';
      var current = document.querySelector(selector);
      var incoming = html.querySelector(selector);
      if (current) {
        window.clearInterval(current.zicoReleaseTimer);
        var mount = getReleaseScope(current);
        if (mount && !current.contains(mount)) mount.remove();
      }
      if (!incoming) {
        if (current) current.remove();
        return;
      }
      var next = incoming.cloneNode(true);
      if (current) current.replaceWith(next);
      else {
        var main = document.querySelector('product-info[id^="MainProduct-"]');
        if (!main) return;
        main.insertAdjacentElement('afterend', next);
      }
      boot(next);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target && event.target.matches && event.target.matches('[data-zico-release-launch]')
        ? event.target
        : event.target && event.target.querySelector('[data-zico-release-launch]');
      if (!root) return;

      window.clearInterval(root.zicoReleaseTimer);

      document.querySelectorAll('[data-zico-release-mounted-for="' + root.id + '"]').forEach(function (mount) {
        mount.remove();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
